/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Products, ProductName, ProductVariantName } from "./Products";
import { ActionHistory } from "./ActionHistory";
import uniqid from "uniqid";

export class Quotation {
    id?: string; // Client-side generated uniqid.

    creationDate?: string;
    validityDate?: string;
    effectiveDate?: string;

    productName: ProductName;
    productVariantName?: ProductVariantName;
    product: Products;

    actionHistory: ActionHistory[];

    static createNew(quotation: Quotation): Quotation {
        return {
            ...quotation,
            id: uniqid(),
        };
    }
}



// WEBPACK FOOTER //
// ./src/types/Quotation.ts